import React from "react";
// @ts-ignore
import ReactLogo from "../../images/loader/loder.svg";
import ErrorPage from "./ErrorPage";

// Define the shape of the expected props
interface ErrorInfo {
    error: string;
    status?: number;
    message?: string;
}

interface PreloaderProps {
    show?: boolean;
    props?: {
        items?: ErrorInfo;
    };
}

const Preloader: React.FC<PreloaderProps> = ({ show, props }) => {
    const hasError = props?.items?.error !== undefined;

    return (
        <>
            {!hasError ? (
                <div
                    className={`preloader bg-soft flex justify-center items-center h-[calc(100vh-130px)] ${
                        show ? "" : "show"
                    }`}
                >
                    <img
                        loading="lazy"
                        className="loader-element animate__animated animate__jackInTheBox"
                        src={ReactLogo}
                        height={100}
                        alt=""
                    />
                </div>
            ) : (
                <ErrorPage
                    statusCode={props?.items?.status}
                    message={props?.items?.message}
                    onClose={()=>{}}
                />
            )}
        </>
    );
};

export default Preloader;
